export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60

export const DIALOG_SM_WIDTH = 600

export const DIALOG_MD_WIDTH = 960    

export const DIALOG_LG_WIDTH = 1280    

export const PROJECT_SIGN = 'banking-app-admin'

export const TOAST_TIMER = 2000

export const MENU_COLOR_LIGHT = '#EEEEEE'
export const MENU_COLOR_DARK = '#002443'

export const CARD_TABLE_FILTER_BG_DARK = '#003459'
export const CARD_TABLE_FILTER_BORDER_DARK = '#004D73'

export const PAGINATION_OPTIONS = {
  PAGE_NUM: 1,
  PAGE_SIZE: 20,
  ITEMS: [5, 10, 20, 50, 100],
}

export const ROUTE_PATH = {
  HOME: '/operational/dashboard',
  FINANCIAL_HOME: '/financial/dashboard',
  LOGIN: '/login',
  CHANGE_PWD: '/change-pwd',
}

export const SCENE_OPTIONS = {
  REGISTER: 1,
  LOGIN: 2,
  FORGOT_PWD: 3,
  FORGOT_PAYMENT_PWD: 4,
  CHANGE_PHONE: 5,
  PIX_KEY: 6,
  VERIFY: 7,
  KYC: 8,
  AVATAR: 9,
  OTHER: 99,
}

export const PIX_KEY_TYPE_OPTIONS = {
  CPF: 1,
  CNPJ: 2,
  EMAIL: 3,
  PHONE: 4,
  EVP: 5,
}
export const PIX_KEY_TYPE_OPTIONS_VALUE = {
  [PIX_KEY_TYPE_OPTIONS.CPF]: 'CPF',
  [PIX_KEY_TYPE_OPTIONS.CNPJ]: 'CNPJ',
  [PIX_KEY_TYPE_OPTIONS.EMAIL]: 'EMAIL',
  [PIX_KEY_TYPE_OPTIONS.PHONE]: 'PHONE',
  [PIX_KEY_TYPE_OPTIONS.EVP]: 'EVP',
}

export const PIX_KEY_STATUS_OPTIONS = {
  ACTIVE: 1,
  INACTIVE: 2,
  BLOCKED: 3,
  DELETED: 4,
}

export const PIX_KEY_STATUS_OPTIONS_VALUE = {
  [PIX_KEY_STATUS_OPTIONS.ACTIVE]: 'ACTIVE',
  [PIX_KEY_STATUS_OPTIONS.INACTIVE]: 'INACTIVE',
  [PIX_KEY_STATUS_OPTIONS.BLOCKED]: 'BLOCKED',
  [PIX_KEY_STATUS_OPTIONS.DELETED]: 'DELETED',
}

export const DOCUMENT_TYPE_OPTIONS = {
  CPF: 1,
  CNPJ: 2,
}
export const DOCUMENT_TYPE_OPTIONS_VALUE = {
  [DOCUMENT_TYPE_OPTIONS.CPF]: 'CPF',
  [DOCUMENT_TYPE_OPTIONS.CNPJ]: 'CNPJ',
}

export const ACCOUNT_TYPE_OPTIONS = {
  CHECKING: 1,
  SALARY: 2,
  SAVINGS: 3,
  PAYMENT: 4,
}

export const ACCOUNT_TYPE_OPTIONS_VALUE = {
  [ACCOUNT_TYPE_OPTIONS.CHECKING]: 'Checking',
  [ACCOUNT_TYPE_OPTIONS.SALARY]: 'Salary',
  [ACCOUNT_TYPE_OPTIONS.SAVINGS]: 'Savings',
  [ACCOUNT_TYPE_OPTIONS.PAYMENT]: 'Payment',
}

export const TEAM_ROLE_OPTIONS = {
  UNSPECIFIED: 0,
  OWNER: 1,
  MAIN_MEMBER: 2,
  MEMBER: 3,
}

export const TEAM_ROLE_OPTIONS_VALUE = {
  [TEAM_ROLE_OPTIONS.UNSPECIFIED]: 'Unspecified',
  [TEAM_ROLE_OPTIONS.OWNER]: 'Owner',
  [TEAM_ROLE_OPTIONS.MAIN_MEMBER]: 'Main Member',
  [TEAM_ROLE_OPTIONS.MEMBER]: 'Member',
}

export const TEAM_ACCOUNT_STATUS_OPTIONS = {
  UNSPECIFIED: 0,
  ACTIVE: 1,
  INACTIVE: 2,
}

export const TEAM_ACCOUNT_STATUS_OPTIONS_VALUE = {
  [TEAM_ACCOUNT_STATUS_OPTIONS.UNSPECIFIED]: 'Unspecified',
  [TEAM_ACCOUNT_STATUS_OPTIONS.ACTIVE]: 'Active',
  [TEAM_ACCOUNT_STATUS_OPTIONS.INACTIVE]: 'Inactive',
}

export const TRADE_STATUS_OPTIONS = {
  PENDING: 1,
  COMPLETED: 2,
  FAILED: 3,
  CANCELLED: 4,
  PROCESSING: 5,
  REFUNDED: 6,
  PARTIALLY_REFUNDED: 7,
  DISPUTED: 8,
}

export const TRADE_STATUS_OPTIONS_VALUE = {
  [TRADE_STATUS_OPTIONS.PENDING]: 'PENDING',
  [TRADE_STATUS_OPTIONS.COMPLETED]: 'COMPLETED',
  [TRADE_STATUS_OPTIONS.FAILED]: 'FAILED',
  [TRADE_STATUS_OPTIONS.CANCELLED]: 'CANCELLED',
  [TRADE_STATUS_OPTIONS.PROCESSING]: 'PROCESSING',
  [TRADE_STATUS_OPTIONS.REFUNDED]: 'REFUNDED',
  [TRADE_STATUS_OPTIONS.PARTIALLY_REFUNDED]: 'PARTIALLY_REFUNDED',
  [TRADE_STATUS_OPTIONS.DISPUTED]: 'DISPUTED',
}

export const TRADE_TYPE_OPTIONS = {
  PAYMENT: 1,
  REFUND: 2,
  TRANSFER: 3,
  WITHDRAWAL: 4,
  DEPOSIT: 5,
}

export const TRADE_TYPE_OPTIONS_VALUE = {
  [TRADE_TYPE_OPTIONS.PAYMENT]: 'PAYMENT',
  [TRADE_TYPE_OPTIONS.REFUND]: 'REFUND',
  [TRADE_TYPE_OPTIONS.TRANSFER]: 'TRANSFER',
  [TRADE_TYPE_OPTIONS.WITHDRAWAL]: 'WITHDRAWAL',
  [TRADE_TYPE_OPTIONS.DEPOSIT]: 'DEPOSIT',
}

export const FLOW_DIRECTION_OPTIONS = {
  IN: 1,
  OUT: 2,
}

export const FLOW_DIRECTION_OPTIONS_VALUE = {
  [FLOW_DIRECTION_OPTIONS.IN]: 'In',
  [FLOW_DIRECTION_OPTIONS.OUT]: 'Out'
}

export const TRADE_EVENT_TYPE_OPTIONS = {
  PAYMENT_IN: 1,
  PAYMENT_OUT: 2,
  REFUNT_IN: 3,
  REFUNT_OUT: 4,
}

export const TRADE_EVENT_TYPE_OPTIONS_VALUE = {
  [TRADE_EVENT_TYPE_OPTIONS.PAYMENT_IN]: 'Payin',
  [TRADE_EVENT_TYPE_OPTIONS.PAYMENT_OUT]: 'Payout',
  [TRADE_EVENT_TYPE_OPTIONS.REFUNT_IN]: 'Refuntin',
  [TRADE_EVENT_TYPE_OPTIONS.REFUNT_OUT]: 'Refuntout',
}

export const DEVICE_TYPE_OPTIONS = {
  IOS: 1,
  ANDROID: 2,
  WEB: 3,
  OTHER: 99,
}

export const DEVICE_TYPE_OPTIONS_VALUE = {
  [DEVICE_TYPE_OPTIONS.IOS]: 'IOS',
  [DEVICE_TYPE_OPTIONS.ANDROID]: 'ANDROID',
  [DEVICE_TYPE_OPTIONS.WEB]: 'WEB',
  [DEVICE_TYPE_OPTIONS.OTHER]: 'OTHER',
}

export const PAYMENT_METHOD_OPTIONS = {
  UNSPECIFIED: 0,
  PIX: 1,
  CARD: 2,
  TED: 3,
  BOLETO: 4,
  BOOK_TRANSFER: 5,
}

export const PAYMENT_METHOD_OPTIONS_VALUE = {
  [PAYMENT_METHOD_OPTIONS.UNSPECIFIED]: 'UNSPECIFIED',
  [PAYMENT_METHOD_OPTIONS.PIX]: 'PIX',
  [PAYMENT_METHOD_OPTIONS.CARD]: 'CARD',
  [PAYMENT_METHOD_OPTIONS.TED]: 'TED',
  [PAYMENT_METHOD_OPTIONS.BOLETO]: 'BOLETO',
  [PAYMENT_METHOD_OPTIONS.BOOK_TRANSFER]: 'BOOK_TRANSFER',
}

export const BILLING_TYPE_OPTIONS = {
  ONBOARDING_FEE: 1,
  MONTHLY_FEE: 2,
  ACCUMULATED_TXN_FEE: 3,
  ADDITIONAL_FEE: 4,
}

export const BILLING_TYPE_OPTIONS_VALUE = {
  [BILLING_TYPE_OPTIONS.ONBOARDING_FEE]: 'ONBOARDING_FEE',
  [BILLING_TYPE_OPTIONS.MONTHLY_FEE]: 'MONTHLY_FEE',
  [BILLING_TYPE_OPTIONS.ACCUMULATED_TXN_FEE]: 'ACCUMULATED_TXN_FEE',
  [BILLING_TYPE_OPTIONS.ADDITIONAL_FEE]: 'ADDITIONAL_FEE',
}

export const BILLING_STATUS_OPTIONS = {
  CREATED: 1,
  PROCESSING: 2,
  PAID: 3,
  FAILED: 4,
  CANCELLED: 5,
}

export const BILLING_STATUS_OPTIONS_VALUE = {
  [BILLING_STATUS_OPTIONS.CREATED]: 'CREATED',
  [BILLING_STATUS_OPTIONS.PROCESSING]: 'PROCESSING',
  [BILLING_STATUS_OPTIONS.PAID]: 'PAID',
  [BILLING_STATUS_OPTIONS.FAILED]: 'FAILED',
  [BILLING_STATUS_OPTIONS.CANCELLED]: 'CANCELLED',
}

export const BILLING_FEE_MODE_OPTIONS = {
  FIXED_PER_TXN: 1,
  PERCENTAGE: 2,
}

export const BILLING_FEE_MODE_OPTIONS_VALUE = {
  [BILLING_FEE_MODE_OPTIONS.FIXED_PER_TXN]: 'FIXED_PER_TXN',
  [BILLING_FEE_MODE_OPTIONS.PERCENTAGE]: 'PERCENTAGE',
}

export const BILLING_TRANSACTION_TYPE_OPTIONS = {
  PIX: 1,
  PIX_REFUND: 2,
  TED: 3,
  INTERNAL_BANK_TRANSFER: 4,
}

export const BILLING_TRANSACTION_TYPE_OPTIONS_VALUE = {
  [BILLING_TRANSACTION_TYPE_OPTIONS.PIX]: 'PIX',
  [BILLING_TRANSACTION_TYPE_OPTIONS.PIX_REFUND]: 'PIX_REFUND',
  [BILLING_TRANSACTION_TYPE_OPTIONS.TED]: 'TED',
  [BILLING_TRANSACTION_TYPE_OPTIONS.INTERNAL_BANK_TRANSFER]: 'INTERNAL_BANK_TRANSFER',
}

export const BILLING_DIRECTION_OPTIONS = {
  IN: 1,
  OUT: 2,
}

export const BILLING_DIRECTION_OPTIONS_VALUE = {
  [BILLING_DIRECTION_OPTIONS.IN]: 'IN',
  [BILLING_DIRECTION_OPTIONS.OUT]: 'OUT',
}

export const PAYMENT_VARIANT_OPTIONS = {
  UNSPECIFIED: 0,
  PIX_MANUAL: 1,
  PIX_KEY: 2,
  STATIC_QRCODE: 3,
  DYNAMIC_QRCODE: 4,
  AUTO_PIX: 5,
  TED_MANUAL: 6,
  BOOK_TRANSFER_MANUAL: 7,
}

export const PAYMENT_VARIANT_OPTIONS_VALUE = {
  [PAYMENT_VARIANT_OPTIONS.UNSPECIFIED]: 'UNSPECIFIED',
  [PAYMENT_VARIANT_OPTIONS.PIX_MANUAL]: 'PIX MANUAL',
  [PAYMENT_VARIANT_OPTIONS.PIX_KEY]: 'PIX',
  [PAYMENT_VARIANT_OPTIONS.STATIC_QRCODE]: 'STATIC QRCODE',
  [PAYMENT_VARIANT_OPTIONS.DYNAMIC_QRCODE]: 'DYNAMIC QRCODE',
  [PAYMENT_VARIANT_OPTIONS.AUTO_PIX]: 'AUTO PIX',
  [PAYMENT_VARIANT_OPTIONS.TED_MANUAL]: 'TED MANUAL',
  [PAYMENT_VARIANT_OPTIONS.BOOK_TRANSFER_MANUAL]: 'BOOK TRANSFER MANUAL',
}

export const TIMEZONE_KEY = `${PROJECT_SIGN}-timezone`

export const TOKEN_KEY = `${PROJECT_SIGN}-token`

export const REFRESH_TOKEN_KEY = `${PROJECT_SIGN}-refresh-token`

export const CHANGE_PASSWORD_TOKEN_KEY = `${PROJECT_SIGN}-change-password-token`

export const PENDING_CHANGE_PWD_OLD_KEY = `${PROJECT_SIGN}-pending-change-pwd-old`

export const PENDING_CHANGE_PWD_EMAIL_KEY = `${PROJECT_SIGN}-pending-change-pwd-email`

export const AUTH_LOCALE_RELOAD_PATHS = new Set([
  ROUTE_PATH.LOGIN,
  ROUTE_PATH.CHANGE_PWD,
  '/operational/infractions-automation',
])

export const USER_INFO_KEY = `${PROJECT_SIGN}-user-info`

export const PRIMARY_COLOR = '#2BC196'